<template>
  <v-tooltip
    v-if="!disabled"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        fab
        icon
        label
        :iconI="iconName"
        small
        color="secondary"
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
  <avs-button
    v-else
    v-bind="$attrs"
    v-on="$listeners"
    icon
    label
    iconI="mdi-download-off"
    fab
    small
    disabled
  />
</template>

<script>
export default {
  name: "DownloadButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    },
    iconName: {
      type: String,
      default: "mdi-download"
    }
  }
}
</script>
